module.exports = __webpack_public_path__ + "img/pain_campagne_crumb_shot.551a4ea1.jpg";